import { PropsWithRef, useMemo } from 'react';

import _ from 'lodash';
import { formatShortUUid } from '../utilities';
import {
  CheckboxGroupEntry,
  CheckboxGroup,
} from '../../../components/CheckboxGroup';

export interface EventsProps {
  eventIds: string[];
  selectedEventIds: Set<string>;
  setSelectedEventIds: (value: Set<string>) => void;
}

export function Events({
  eventIds,
  selectedEventIds,
  setSelectedEventIds,
}: PropsWithRef<EventsProps>): JSX.Element {
  const values = useMemo<CheckboxGroupEntry[]>(
    () =>
      _.map(eventIds, (name: string) => ({
        id: name,
        label: formatShortUUid(name),
      })),
    [eventIds]
  );

  return (
    <CheckboxGroup
      titleId="content.metrics.filters.events.title"
      allId="content.metrics.filters.events.all"
      values={values}
      selectedValues={selectedEventIds}
      setSelectedValues={setSelectedEventIds}
    />
  );
}
